export const DIFF_DETECTOR_OPTION = {
    IGNORE_SRC: 'IGNORE_SRC',
    IGNORE_REPORTED_AS_LABELS: 'IGNORE_REPORTED_AS_LABELS',
} as const;

export type DiffDetectorOptionType = (typeof DIFF_DETECTOR_OPTION)[keyof typeof DIFF_DETECTOR_OPTION];

export const SUPPORTED_DATA = {
    CD: 'CD',
    REPORTED_AS_LABELS: 'REPORTED_AS_LABELS',
    FIELD_SRC: 'FIELD_SRC',
} as const;

export type SupportedDataType = (typeof SUPPORTED_DATA)[keyof typeof SUPPORTED_DATA];
